import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoimagicacab() {



  const cardData = {
    keyword: " Mumbai to Imagica Cab ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Imagica cab services, ensuring a safe, fun, and hassle-free journey for families, friends, school groups, and corporate outings. Imagicaa Theme Park is one of India’s most popular entertainment destinations, known for thrilling rides, water parks, snow park experiences, live shows, and family attractions, making it a perfect one-day or weekend getaway from Mumbai. Our professional drivers and well-maintained vehicles ensure a smooth travel experience throughout the journey. The Mumbai to Imagica route covers approximately 80 to 90 km via the Mumbai–Pune Expressway and takes around 1.5 to 2.5 hours depending on traffic conditions and weekends rush. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Imagica travel.",

"topPlaces": [
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa Theme Park is a world-class entertainment destination featuring thrilling rides, roller coasters, themed zones, and live shows. It is designed for all age groups, offering adventure rides for thrill seekers and family-friendly attractions for kids and adults. The park’s vibrant atmosphere makes it one of the most visited amusement parks near Mumbai."
  },
  {
    "title": "Imagicaa Water Park",
    "description": "Imagicaa Water Park is a popular attraction within the Imagica complex offering water slides, wave pools, lazy rivers, and splash zones. It is perfect for beating the heat and enjoying a fun-filled day with family and friends in a tropical-themed environment."
  },
  {
    "title": "Imagica Snow Park",
    "description": "Imagica Snow Park offers a unique indoor snow experience with real snow, ice slides, snowball fights, and sub-zero temperatures. It is a favorite attraction for visitors looking to experience winter-like conditions in Maharashtra."
  },
  {
    "title": "Khopoli Scenic Surroundings",
    "description": "Khopoli is the town near Imagica known for its scenic Sahyadri mountain views, waterfalls during monsoon, and lush greenery. It provides a refreshing natural backdrop to the entertainment experience of Imagicaa."
  },
  {
    "title": "Pali Ashtavinayak Temple",
    "description": "Pali is home to the famous Ballaleshwar Ashtavinayak Temple dedicated to Lord Ganesha. It is a spiritually significant stop near Imagica and attracts devotees traveling between Mumbai and Pune regions."
  },
  {
    "title": "Kundalika River Rafting Zone",
    "description": "The Kundalika River near Kolad offers thrilling white-water rafting experiences, especially during monsoon and post-monsoon seasons. It is a popular adventure extension for visitors traveling to Imagica."
  },
  {
    "title": "Zenith Waterfall (Monsoon Spot)",
    "description": "Zenith Waterfall near Khopoli becomes active during monsoon, offering a scenic and refreshing stop along the Mumbai–Imagica route. It is a popular photography and nature break spot."
  },
  {
    "title": "Lonavala Stopover",
    "description": "Lonavala is often combined with Imagica trips, offering attractions like Bhushi Dam, Tiger’s Leap, and scenic viewpoints, making the journey more enjoyable and flexible for tourists."
  },
  {
    "title": "Adlabs Imagica Mall & Food Zone",
    "description": "The Imagica food and retail zone offers restaurants, snack counters, and shopping outlets inside the park complex, providing a complete entertainment and dining experience for visitors."
  },
  {
    "title": "Mumbai–Pune Expressway Drive",
    "description": "The Mumbai–Pune Expressway offers a smooth and scenic drive with tunnels, bridges, and mountain views, making the journey to Imagica itself a memorable part of the trip."
  }
],






services: [
  {
    name: "Mumbai to Imagica Cab",
    description: "Mumbai to Imagica cab service offers a fun and comfortable journey to Adlabs Imagica, one of India’s top theme parks. Located near Khopoli, the route via the Mumbai-Pune Expressway ensures a smooth and quick drive. Ideal for families, friends, and group outings, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance the experience. It guarantees a hassle-free and enjoyable trip."
  },
  {
    name: "Mumbai to Imagica Taxi",
    description: "Mumbai to Imagica taxi provides convenient and private travel with door-to-door pickup and drop. This service is perfect for travelers planning a day trip to the theme park. Vehicles are clean and driven by experienced chauffeurs. Flexible timings make planning easy. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Imagica Cab Service",
    description: "Mumbai to Imagica cab service is designed for quick and reliable travel to the theme park. The expressway route ensures fast connectivity and a comfortable drive. This service is ideal for family trips, school groups, and corporate outings. Vehicles are maintained for safety and comfort. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Imagica Taxi Service",
    description: "Mumbai to Imagica taxi service offers dependable transportation for tourists and families visiting the park. Clean vehicles and trained drivers ensure a pleasant ride. Flexible scheduling allows easy trip planning. Door-to-door service adds convenience. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Imagica",
    description: "Cab from Mumbai to Imagica provides a personalized travel experience with flexible pickup and drop options. Travelers can enjoy a relaxed and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a comfortable road trip."
  },
  {
    name: "Taxi from Mumbai to Imagica",
    description: "Taxi from Mumbai to Imagica offers a convenient and efficient way to reach the theme park. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for day trips and weekend outings. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Imagica Cab Booking",
    description: "Mumbai to Imagica cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Imagica Taxi Booking Online",
    description: "Mumbai to Imagica taxi booking online provides a quick and convenient way to plan your trip. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Imagica Cab Price",
    description: "Mumbai to Imagica cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Imagica Taxi Fare",
    description: "Mumbai to Imagica taxi fare is designed to be affordable and competitive for short-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Imagica One Way Cab",
    description: "Mumbai to Imagica one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for day trips. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Imagica Round Trip Taxi",
    description: "Mumbai to Imagica round trip taxi is ideal for travelers planning a same-day return after enjoying the theme park. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for families and groups. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Imagica Innova Cab",
    description: "Mumbai to Imagica Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for group outings. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Imagica Ertiga Cab",
    description: "Mumbai to Imagica Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Imagica Sedan Cab",
    description: "Mumbai to Imagica sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for short-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a quick journey."
  },
  {
    name: "Mumbai to Imagica SUV Taxi",
    description: "Mumbai to Imagica SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Imagica Cab",
    description: "Cheap Mumbai to Imagica cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Imagica Taxi Service",
    description: "Best Mumbai to Imagica taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Imagica Cab", "Mumbai to Imagica Taxi"],
  ["Mumbai to Imagica Cab Service", "Mumbai to Imagica Taxi Service"],
  ["Cab from Mumbai to Imagica", "Taxi from Mumbai to Imagica"],
  ["Mumbai to Imagica Cab Booking", "Mumbai to Imagica Taxi Booking Online"],
  ["Mumbai to Imagica Cab Price", "Mumbai to Imagica Taxi Fare"],
  ["Mumbai to Imagica One Way Cab", "Mumbai to Imagica Round Trip Taxi"],
  ["Mumbai to Imagica Innova Cab", "Mumbai to Imagica Ertiga Cab"],
  ["Mumbai to Imagica Sedan Cab", "Mumbai to Imagica SUV Taxi"],
  ["Cheap Mumbai to Imagica Cab", "Best Mumbai to Imagica Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Fun & Comfortable Mumbai to Imagica Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Imagica cab service, perfect for family outings, group trips, and weekend fun."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-trained on the Mumbai–Pune Expressway, ensuring safe driving and quick travel to Imagica."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Imagica cab service operates 24/7, allowing flexible travel plans anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return options for Imagica trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Imagica cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Imagica cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Imagica for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Imagica?", answer: "The distance is approximately 75 to 90 km and takes around 2 to 3 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Imagica cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and holidays." },
  { question: "Do you provide same-day return trips?", answer: "Yes, we offer same-day return cab services for Mumbai to Imagica trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "The Mumbai to Imagica trip with Royal Route Cabs was very smooth and enjoyable. The driver was punctual and made sure we reached the destination comfortably and on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Kulkarni",
    feedback: "Great experience for our Mumbai to Imagica family outing. The cab was clean, ride was comfortable, and the service was reliable throughout the journey.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Imagica Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-imagica-cab.jpg", // replace if needed
  "description": "Book Mumbai to Imagica cab with Royal Route Cabs for a safe and comfortable travel experience to Adlabs Imagica theme park. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-imagica-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Imagica Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Imagica cab at best price with Royal Route Cabs. One-way & round-trip taxi service to Adlabs Imagica with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to imagica cab, mumbai to imagica taxi, mumbai to imagica cab service, mumbai to imagica taxi service, cab from mumbai to imagica, taxi from mumbai to imagica, mumbai to imagica cab booking, mumbai to imagica taxi booking online, mumbai to imagica cab price, mumbai to imagica taxi fare, mumbai to imagica one way cab, mumbai to imagica round trip taxi, mumbai to imagica innova cab, mumbai to imagica ertiga cab, mumbai to imagica sedan cab, mumbai to imagica suv taxi, cheap mumbai to imagica cab, best mumbai to imagica taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoimagicacab;